import { fmtMoney } from "../../lib/format";
import { altTrio, fmtAltValue, fxRuleCaption, hasAltCurrency } from "../../lib/currency";
import InfoTip from "../InfoTip";

// Total (gross) − Sub-consultants = Net. Sits immediately above resourcing so
// principals plan their team against what the firm actually keeps.
// When the project records a non-NZD client currency the converted figure is
// shown in small text beneath — display only, NZD stays the stored truth.
// Forecast months convert at the live ECB rate, months already gone at the
// project's locked rate; the caption states which rates were used.
export function NetFeeStrip({ gross, subs, net, project, scopes, months, fx }) {
  const trio = hasAltCurrency(project)
    ? altTrio(scopes || project?.scopes, months, project, fx)
    : null;
  const alt = (v, testid) => (trio ? (
    <div className="text-[10px] font-mono-num text-[var(--soft-fg)] mt-0.5" data-testid={testid}>
      {fmtAltValue(v, project.currency)}
    </div>
  ) : null);

  return (
    <div className="border border-[var(--ink)]" data-testid="net-fee-strip">
      <div className="grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-[var(--rule)]">
        <div className="px-5 py-4">
          <div className="eyebrow">Total · gross fee</div>
          <div className="font-mono-num text-2xl mt-1" data-testid="net-strip-gross">{fmtMoney(gross)}</div>
          {alt(trio?.gross, "net-strip-gross-alt")}
          <div className="text-[10px] font-mono-num text-[var(--soft-fg)] mt-1">all forecast stages · billed to the client</div>
        </div>
        <div className="px-5 py-4">
          <div className="eyebrow text-[var(--soft-fg)]">Less sub-consultants</div>
          <div className="font-mono-num text-2xl mt-1 text-[#2C4A38]" data-testid="net-strip-subs">
            {subs ? `− ${fmtMoney(subs)}` : fmtMoney(0)}
          </div>
          {alt(trio?.subs, "net-strip-subs-alt")}
          <div className="text-[10px] font-mono-num text-[var(--soft-fg)] mt-1">pass-through cost</div>
        </div>
        <div className="px-5 py-4 bg-[var(--paper-soft)]">
          <div className="eyebrow inline-flex items-center">
            Net fee to the firm
            <InfoTip side="bottom" label="Net fee">
              Gross forecast total minus sub-consultant costs. This is the figure the profitability
              calculator measures the team cost against. Invoicing still works from the gross total —
              the client is billed the full amount including sub-consultant costs.
            </InfoTip>
          </div>
          <div className="font-mono-num text-3xl mt-1" data-testid="net-strip-net">{fmtMoney(net)}</div>
          {alt(trio?.net, "net-strip-net-alt")}
          <div className="text-[10px] font-mono-num text-[var(--soft-fg)] mt-1">plan the team against this</div>
        </div>
      </div>
      {trio && (
        <div className="border-t border-[var(--rule)] px-5 py-2 text-[10px] font-mono-num text-[var(--soft-fg)]" data-testid="net-strip-fx-caption">
          {fxRuleCaption(project, fx)}
        </div>
      )}
    </div>
  );
}
